import './Workcardstyle.css';
import React from 'react'
import { NavLink } from 'react-router-dom';

const WorkCard = (props) => {
  return (
            <div className='project-card'>
                <img  src={props.imagesource} alt='images'/>
                
                    <h2 className='project-title text-center mt-1'>
                    {props.title}
                    </h2>
                <div className='project-details'>
                    <p>
                        
                    {props.text}
                    
                    </p>
                </div>
                <div className='pro-btn'>
                    <NavLink to={props.Spotify} target='blank'
                    className='Bbtn'>Spotify</NavLink>
                    <NavLink to={props.Apple} target='blank'
                    className='Bbtn'>Apple</NavLink>
                </div>
            </div>
  )
}

export default WorkCard